import React from "react";

const CardHeadline = ({ children }) => {
  return <h1 className="card-headline">{children}</h1>;
};

export default CardHeadline;
